export default {
      id: "icon-menu-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-menu",
      toString: function () {
        return this.url;
      }
    }